// User-provided starter values. Used only to populate an editable draft, never by the calculator.
const BASE_ROWS = Object.freeze([
  [1, 12, 2],
  [1.5, 12, 3],
  [2, 12, 3.5],
  [2.5, 12, 4.5],
  [3, 16, 5],
  [4, 24, 7],
  [5, 40, 9],
  [6, 40, 10],
  [8, 60, 15],
  [10, 60, 18],
  [12, 60, 21],
].map(row => Object.freeze(row)));

const keyOf = row => [row.thickness_mm, row.v_opening_mm, row.angle_deg]
  .map(value => Number(String(value).trim().replace(",", "."))).join("|");

export const mergeBaseDeductionRows = (existingRows, createId = () => crypto.randomUUID()) => {
  const keys = new Set(existingRows.map(keyOf));
  const additions = [];
  for (const [thickness_mm, v_opening_mm, deduction_mm] of BASE_ROWS) {
    const row = { thickness_mm, v_opening_mm, deduction_mm, angle_deg: 90 };
    const key = keyOf(row);
    if (!keys.has(key)) {
      additions.push({ ...row, id: createId(), notes: "" });
      keys.add(key);
    }
  }
  return { rows: additions.length ? [...existingRows, ...additions] : existingRows, addedCount: additions.length };
};